import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { GlobalFunction } from '../public/globalFunction';
import { Uris } from '../public/Uris';

@Injectable({
  providedIn: 'root',
})
export class IncidencesService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public GlobalFunction: GlobalFunction
  ) {}

  getAIncidences(query) {
    return this.http
      .get(`${Uris.AGRONODO_A_INCIDENCES}${query}`, this.GlobalFunction.headers())
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getTIncidences(query) {
    return this.http
      .get(`${Uris.AGRONODO_T_INCIDENCES}${query}`, this.GlobalFunction.headers())
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  setAIncidence(value) {
    return this.http
      .post(
        `${Uris.AGRONODO_A_INCIDENCES}`,
        value,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  setTIncidence(value) {
    return this.http
      .post(
        `${Uris.AGRONODO_T_INCIDENCES}`,
        value,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  editAIncidence(id, object) {
    return this.http
      .patch(
        `${Uris.AGRONODO_A_INCIDENCES}${id}/`,
        object,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  editTIncidence(id, object) {
    return this.http
      .patch(
        `${Uris.AGRONODO_T_INCIDENCES}${id}/`,
        object,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteAIncidence(id) {
    return this.http
      .delete(
        `${Uris.AGRONODO_A_INCIDENCES}${id}/`,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteTIncidence(id) {
    return this.http
      .delete(
        `${Uris.AGRONODO_T_INCIDENCES}${id}/`,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }
}
